import type { FaireCollectionEntity } from "../../entity_types/collection";

export const col_fireside_fall: FaireCollectionEntity = {
  token: "col_fireside-fall",
  type: "collection",
  name: "Fireside Fall",
  description: "Warm and cozy autumn vibes.",
  thumbnailUrl:
    "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop",
  season: "fall",
  itemCount: 34,
  brandToken: "catalog_brand_audreys_home_gift",
  productTokens: [],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
